import { Subject } from 'rxjs';

import { Align } from './../../../core/enums/align.enum';
import { DataType } from './../../../core/enums/datatype.enum';
import { Metadata } from 'src/app/core/list/metadata/metadata.component';
import { DateTimeUtil } from 'src/app/core/framework/utils/date-time-util';
import { ButtonType } from 'src/app/core/enums/buttontype.enum';
import { ToasterService } from 'src/app/core/framework/toaster/toaster.service';
import { Lote } from './lote.model';
import { GridUtil } from 'src/app/core/list/grid-util';


export class LoteMetadata {

  public static dateTimeUtil = new DateTimeUtil();

  static getMetadata(subjectIdLoteDistribuirParaUnidade: Subject<number>,
                      subjectIdLoteEnvioParaInventario: Subject<number>,
                      usuarioPodeAcessarTodasUnidades: boolean,
                      exibirUnidade: boolean,
                      toasterService: ToasterService): Metadata[] {
    return [
      {
        fieldId: 'unidade.nome',
        fieldName: 'Unidade',
        hidden: !exibirUnidade
      }
      , {
        fieldId: 'id',
        fieldName: 'Id Lote',
        dataType: DataType.NUMBER,
        hidden: true
      },
      {
        fieldId: 'status',
        fieldName: 'St.',
        title: 'Status',
        align: Align.CENTER,
        dataType: DataType.TEXT,
        hidden: true
      },
      {
        fieldId: 'produto.tipo',
        fieldName: 'Tipo',
        hidden: true
      }
      , {
        fieldId: 'produto.id',
        fieldName: 'Id',
        title: 'Id Produto'
      }
      , {
        fieldId: 'produto.descricao',
        fieldName: 'Produto'
      }
      , {
        fieldId: 'descricao',
        fieldName: 'Lote',
      }
      , {
        fieldId: 'valor',
        fieldName: 'Valor',
        dataType: DataType.CURRENCY
      }
      , {
        fieldId: 'quantidade',
        fieldName: 'Quant.',
        dataType: DataType.NUMBER,
        align: Align.RIGHT
      }
      , {
          fieldId: 'dataVencimento',
          fieldName: 'Vencimento',
          align: Align.CENTER,
          dataType: DataType.HTML,
          fnValorCelula: (data: any) => {
            if ( !data.dataVencimento ) {
              return '';
            }

            let cssClass = '';
            if ( new Date(data.dataVencimento) < new Date() ) {
              cssClass = 'danger';
            }
            return `<label class='${cssClass}'>${LoteMetadata.dateTimeUtil.dateToDiaMesAno(data.dataVencimento)}</label>`;
          }
      }
      , {
        fieldId: '',
        fieldName: '<i class="material-icons lista-icone-titulo">double_arrow</i> Unidade',
        title: 'Distribuir para Unidade',
        hidden: !usuarioPodeAcessarTodasUnidades,
        dataType: DataType.BUTTON,
        buttonType: ButtonType.DOUBLE_ARROW,
        fnOperacaoNaoPermitida: (data: Lote) => (new Date(data.dataVencimento) < new Date()),
        fnClick: (event: any, data: any) => {
          if ( ( !(new Date(data.dataVencimento) < new Date()) ) && subjectIdLoteDistribuirParaUnidade ) {
            event.idLote = data.id;
            subjectIdLoteDistribuirParaUnidade.next(event);
          }
        }
      }
      , {
        fieldId: '',
        fieldName: '<i class="material-icons lista-icone-titulo">double_arrow</i> Setor',
        title: 'Enviar para Setor',
        dataType: DataType.BUTTON,
        buttonType: ButtonType.DOUBLE_ARROW,
        fnOperacaoNaoPermitida: (data: Lote) => (new Date(data.dataVencimento) < new Date()),
        fnClick: (event: any, data: any) => {
          const unidadeEstaSelecionada = !exibirUnidade;
          if ( unidadeEstaSelecionada ) {
            if ( subjectIdLoteEnvioParaInventario ) {
              event.idLote = data.id;
              subjectIdLoteEnvioParaInventario.next(event);
            }
          }
          else {
            toasterService.info('Favor selecionar uma Unidade');
          }
        }
      }
    ];
  }
}
